var render, staticRenderFns
import script from "./manualReportForm.vue?vue&type=script&lang=js"
export * from "./manualReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168218a",
  null
  
)

export default component.exports